import logo from '../../../img/logo.png';
import text_logo from '../../../img/text_logo.png';
import './HeaderIndex.css';

function HeaderIndex() {
 
  return (
    <div className="index-header">
      <div>
        <img src={logo} className="index-logo"/>
      </div>
    </div>
  );
}

export default HeaderIndex;
